// External Dependencies:
import React from 'react'

class MapMarker extends React.Component {
	render() {
		const { isSelected, lat, lng, group, title, freq, id, onClick } = this.props
		let classNameWrap = 'bubble-marker-wrap'
		let className = 'bubble-marker -group-' + group

		if ( ! lat || ! lng ) {
			return null
		}

		if ( isSelected ) {
			classNameWrap += ' is-active'
		}

		return (
			<div className={ classNameWrap } onClick={ onClick } data-id={ id }>
				<div className={ className }>
					<i className="icon-radio-waves" aria-hidden="true"></i>
				</div>

				<div className="bubble-info-window">
					<div className="-title">{ title }</div>
					<div className="-freq">{ freq }</div>
				</div>
			</div>
		)
	}
}

export default MapMarker
